module.exports = __webpack_public_path__ + "img/Weapon_68.724470ac.png";